import React from 'react';
import EditIcon from '@material-ui/icons/Edit';

export const Edit = React.memo((props) => <EditIcon {...props} />);
